export const touchModeKeyboardShortcuts = {
  escape: 'Escape',
} as const;
